const fa = {
  nav: {
    home: 'خانه',
    services: 'خدمات',
    about: 'درباره ما',
    contact: 'تماس',
  },
  hero: {
    tagline: 'هوش مصنوعی • راهکارهای نرم‌افزاری • نوآوری',
    title: 'مهندسی',
    titleHighlight: 'هوش فردا',
    subtitle: 'پیشگام در ارائه راهکارهای هوش مصنوعی، تحلیل داده و سیستم‌های نرم‌افزاری هوشمند از سال ۱۳۹۴. ما چالش‌های پیچیده را به راهکارهای فناورانه تبدیل می‌کنیم.',
    cta: 'مشاهده پروژه‌ها',
    ctaSecondary: 'تماس با ما',
  },
  services: {
    title: 'تخصص‌های ما',
    subtitle: 'راهکارهای جامع هوش مصنوعی و نرم‌افزار برای تعالی سازمانی',
    items: [
      {
        icon: '◇',
        title: 'هوش مصنوعی',
        description: 'مدل‌های هوش مصنوعی سفارشی، خطوط یادگیری ماشین و سیستم‌های اتوماسیون هوشمند متناسب با نیازهای کسب‌وکار شما.',
      },
      {
        icon: '△',
        title: 'داده‌کاوی و تحلیل',
        description: 'استخراج بینش‌های کاربردی از داده‌های شما با تحلیل پیشرفته، مدل‌سازی پیش‌بینی و راهکارهای هوش تجاری.',
      },
      {
        icon: '○',
        title: 'پردازش زبان طبیعی',
        description: 'تحلیل متن، تشخیص احساسات، چت‌بات‌ها و سیستم‌های درک زبان برای فارسی و انگلیسی.',
      },
      {
        icon: '□',
        title: 'بینایی ماشین',
        description: 'تشخیص تصویر، شناسایی اشیاء، تحلیل ویدئو و سیستم‌های بازرسی بصری برای کاربردهای صنعتی.',
      },
      {
        icon: '◈',
        title: 'رباتیک و شبیه‌سازی',
        description: 'اتوماسیون فرآیندهای رباتیک، دوقلوهای دیجیتال و راهکارهای واقعیت مجازی برای آموزش و تجسم.',
      },
      {
        icon: '⬡',
        title: 'توسعه نرم‌افزار',
        description: 'برنامه‌های تحت وب و موبایل، سیستم‌های سازمانی و نرم‌افزار سفارشی متناسب با گردش کار شما.',
      },
    ],
  },
  about: {
    title: 'درباره ارما رایان برنا',
    p1: 'شرکت ارما رایان برنا در سال ۱۳۹۴ تأسیس شد و یک شرکت پیشرو فناوری ایرانی متخصص در هوش مصنوعی و راهکارهای جامع فناوری اطلاعات است. ما به بخش‌های دولتی و خصوصی از جمله وزارتخانه‌ها، سازمان‌ها و شرکت‌ها خدمات ارائه می‌دهیم.',
    p2: 'تیم ما تخصص فنی عمیق را با درک عملی کسب‌وکار ترکیب می‌کند تا راهکارهایی ارائه دهد که ارزش واقعی ایجاد کنند. از مفهوم تا استقرار و پشتیبانی مداوم، ما در سراسر سفر تحول دیجیتال با مشتریانمان همراه هستیم.',
    p3: 'ما فعالانه با شرکای داخلی و بین‌المللی همکاری می‌کنیم تا راهکارهای فناوری در سطح جهانی را به بازار ایران بیاوریم و همچنین خدمات خود را در سطح جهانی گسترش دهیم.',
    stats: [
      { number: '۱۳۹۴', label: 'تأسیس' },
      { number: '+۱۰۰', label: 'پروژه تحویل‌شده' },
      { number: '+۵۰', label: 'مشتری سازمانی' },
      { number: '۲۴/۷', label: 'پشتیبانی' },
    ],
  },
  contact: {
    title: 'بیایید با هم بسازیم',
    subtitle: 'آماده تحول کسب‌وکار خود با راهکارهای هوشمند هستید؟ با تیم ما تماس بگیرید.',
    address: 'آدرس',
    addressValue: 'تهران، خیابان مرزداران، خیابان ناهید، خیابان بهروز رضایی، پلاک ۲۳',
    postalCode: 'کد پستی: ۱۴۶۱۷۸۵۷۹۱',
    email: 'ایمیل',
    phone: 'تلفن',
    form: {
      name: 'نام شما',
      email: 'ایمیل شما',
      message: 'پیام شما',
      submit: 'ارسال پیام',
      sending: 'در حال ارسال...',
      success: 'پیام با موفقیت ارسال شد!',
      error: 'خطا در ارسال. لطفاً دوباره تلاش کنید.',
    },
  },
  footer: {
    copyright: '© ۱۴۰۳ ارما رایان برنا. تمامی حقوق محفوظ است.',
    registration: 'شماره ثبت: ۴۸۲۱۷۶ | شناسه ملی: ۱۴۰۰۵۳۷۴۹۱۵',
    links: {
      privacy: 'حریم خصوصی',
      terms: 'شرایط استفاده',
    },
  },
  privacy: {
    title: 'حریم خصوصی',
    backToHome: 'بازگشت به صفحه اصلی',
    lastUpdated: 'آخرین به‌روزرسانی: آذر ۱۴۰۳',
    introduction: {
      title: '۱. مقدمه',
      content: 'ارما رایان برنا ("ما"، "ما" یا "شرکت") متعهد به محافظت از حریم خصوصی شماست. این سیاست حریم خصوصی توضیح می‌دهد که چگونه اطلاعات شما را هنگام بازدید از وب‌سایت یا استفاده از خدمات ما جمع‌آوری، استفاده، افشا و محافظت می‌کنیم. با دسترسی به وب‌سایت ما، شما با جمع‌آوری و استفاده از اطلاعات مطابق با این سیاست موافقت می‌کنید.',
    },
    informationCollection: {
      title: '۲. اطلاعاتی که جمع‌آوری می‌کنیم',
      intro: 'ما ممکن است اطلاعات مربوط به شما را به روش‌های مختلف جمع‌آوری کنیم. اطلاعاتی که ممکن است جمع‌آوری کنیم شامل موارد زیر است:',
      items: [
        'اطلاعات شناسایی شخصی (نام، آدرس ایمیل، شماره تلفن) هنگام تماس با ما یا استفاده از خدمات ما',
        'داده‌های فنی مانند آدرس IP، نوع مرورگر، اطلاعات دستگاه و الگوهای استفاده',
        'کوکی‌ها و فناوری‌های ردیابی برای بهبود تجربه مرور شما',
        'اطلاعاتی که شما داوطلبانه از طریق فرم‌ها، نظرسنجی‌ها یا ارتباطات با ما ارائه می‌دهید',
      ],
    },
    useOfInformation: {
      title: '۳. نحوه استفاده از اطلاعات شما',
      intro: 'ما از اطلاعات جمع‌آوری شده برای اهداف مختلف استفاده می‌کنیم، از جمله:',
      items: [
        'ارائه، حفظ و بهبود خدمات ما',
        'پاسخ به سوالات، نظرات یا درخواست‌های شما',
        'ارسال اعلان‌های فنی، به‌روزرسانی‌ها و پیام‌های پشتیبانی',
        'نظارت و تجزیه و تحلیل الگوها و روندهای استفاده',
        'تشخیص، پیشگیری و رسیدگی به مسائل فنی یا تهدیدات امنیتی',
        'رعایت تعهدات قانونی و محافظت از حقوق ما',
      ],
    },
    dataSecurity: {
      title: '۴. امنیت داده',
      content: 'ما اقدامات امنیتی فنی و سازمانی مناسب را برای محافظت از اطلاعات شخصی شما در برابر دسترسی غیرمجاز، تغییر، افشا یا تخریب پیاده‌سازی می‌کنیم. با این حال، هیچ روش انتقالی از طریق اینترنت یا ذخیره‌سازی الکترونیکی ۱۰۰٪ امن نیست و ما نمی‌توانیم امنیت مطلق را تضمین کنیم.',
    },
    cookies: {
      title: '۵. کوکی‌ها و فناوری‌های ردیابی',
      content: 'ما از کوکی‌ها و فناوری‌های ردیابی مشابه برای ردیابی فعالیت در وب‌سایت خود و ذخیره اطلاعات خاص استفاده می‌کنیم. شما می‌توانید به مرورگر خود دستور دهید که همه کوکی‌ها را رد کند یا زمانی که کوکی ارسال می‌شود نشان دهد. با این حال، اگر کوکی‌ها را قبول نکنید، ممکن است نتوانید از برخی بخش‌های وب‌سایت ما استفاده کنید.',
    },
    userRights: {
      title: '۶. حقوق شما',
      intro: 'شما در مورد اطلاعات شخصی خود حقوق خاصی دارید، از جمله:',
      items: [
        'حق دسترسی و دریافت کپی از داده‌های شخصی خود',
        'حق اصلاح اطلاعات نادرست یا ناقص',
        'حق درخواست حذف اطلاعات شخصی خود',
        'حق اعتراض به پردازش داده‌های شخصی خود',
        'حق انتقال داده',
        'حق لغو رضایت در هر زمان',
      ],
    },
    changesToPolicy: {
      title: '۷. تغییرات در این سیاست حریم خصوصی',
      content: 'ما ممکن است گاهی اوقات سیاست حریم خصوصی خود را به‌روزرسانی کنیم. ما شما را از هرگونه تغییر با انتشار سیاست حریم خصوصی جدید در این صفحه و به‌روزرسانی تاریخ "آخرین به‌روزرسانی" مطلع خواهیم کرد. توصیه می‌شود این سیاست حریم خصوصی را به طور دوره‌ای برای هرگونه تغییر بررسی کنید.',
    },
    contactInformation: {
      title: '۸. تماس با ما',
      content: 'اگر سوالی در مورد این سیاست حریم خصوصی یا شیوه‌های داده ما دارید، لطفاً با ما تماس بگیرید:',
      email: 'ایمیل',
      address: 'آدرس',
    },
  },
  terms: {
    title: 'شرایط استفاده',
    backToHome: 'بازگشت به صفحه اصلی',
    lastUpdated: 'آخرین به‌روزرسانی: آذر ۱۴۰۳',
    acceptanceOfTerms: {
      title: '۱. پذیرش شرایط',
      content: 'با دسترسی و استفاده از وب‌سایت و خدمات ارما رایان برنا، شما شرایط و مقررات این توافقنامه را می‌پذیرید و موافقت می‌کنید که به آن پایبند باشید. اگر با موارد فوق موافقت ندارید، لطفاً از این سرویس استفاده نکنید.',
    },
    servicesDescription: {
      title: '۲. توضیحات خدمات',
      content: 'ارما رایان برنا راهکارهای هوش مصنوعی، توسعه نرم‌افزار، تحلیل داده و خدمات فناوری مرتبط را ارائه می‌دهد. ما حق تغییر، تعلیق یا توقف هر جنبه‌ای از خدمات خود را در هر زمان بدون اطلاع قبلی محفوظ می‌داریم.',
    },
    userObligations: {
      title: '۳. تعهدات کاربر',
      intro: 'هنگام استفاده از خدمات ما، شما موافقت می‌کنید که:',
      items: [
        'اطلاعات دقیق، فعلی و کامل را در صورت نیاز ارائه دهید',
        'امنیت اعتبارنامه‌های حساب خود را حفظ کنید و در مورد هرگونه استفاده غیرمجاز به ما اطلاع دهید',
        'از خدمات ما فقط برای اهداف قانونی و مطابق با این شرایط استفاده کنید',
        'تلاش برای دسترسی غیرمجاز به سیستم‌های ما یا دخالت در عملیات سرویس نکنید',
        'از خدمات ما برای انتقال هرگونه محتوای مضر، توهین‌آمیز یا غیرقانونی استفاده نکنید',
        'حقوق مالکیت فکری را رعایت کنید و حقوق دیگران را نقض نکنید',
      ],
    },
    intellectualProperty: {
      title: '۴. مالکیت فکری',
      content: 'تمام محتوا، ویژگی‌ها و عملکرد وب‌سایت و خدمات ما، از جمله اما نه محدود به متن، گرافیک، لوگو، نرم‌افزار و طراحی‌ها، متعلق به ارما رایان برنا است و تحت حمایت قوانین بین‌المللی حق نسخه‌برداری، علامت تجاری و سایر قوانین مالکیت فکری قرار دارد. شما نمی‌توانید بدون اجازه کتبی صریح ما، آثار مشتق شده را تکثیر، توزیع یا ایجاد کنید.',
    },
    limitationOfLiability: {
      title: '۵. محدودیت مسئولیت',
      content: 'در گسترده‌ترین حد مجاز توسط قانون، ارما رایان برنا مسئول هیچگونه خسارت غیرمستقیم، اتفاقی، خاص، پیامد یا تنبیهی، یا از دست دادن سود یا درآمد، چه به طور مستقیم یا غیرمستقیم متحمل شده باشد، یا از دست دادن داده، استفاده، حسن نیت یا سایر ضررهای نامشهود ناشی از استفاده شما از خدمات ما نخواهد بود.',
    },
    termination: {
      title: '۶. فسخ',
      content: 'ما حق فسخ یا تعلیق دسترسی شما به خدمات خود را فوراً، بدون اطلاع قبلی یا مسئولیت، به هر دلیلی، از جمله بدون محدودیت در صورت نقض شرایط، محفوظ می‌داریم. پس از فسخ، حق استفاده شما از خدمات فوراً متوقف می‌شود.',
    },
    governingLaw: {
      title: '۷. قانون حاکم',
      content: 'این شرایط باید مطابق با قوانین جمهوری اسلامی ایران تفسیر و اجرا شود، بدون توجه به مقررات تعارض قوانین آن. هرگونه اختلاف ناشی از این شرایط باید تحت صلاحیت انحصاری دادگاه‌های تهران، ایران باشد.',
    },
    contactInformation: {
      title: '۸. اطلاعات تماس',
      content: 'اگر سوالی در مورد این شرایط استفاده دارید، لطفاً با ما تماس بگیرید:',
      email: 'ایمیل',
      address: 'آدرس',
    },
  },
};

export default fa;
